export function updateTilt(particle, delta) {
  var _particle$tilt$veloci, _particle$tilt$decay;
  if (!particle.tilt || !particle.options.tilt) {
    return;
  }
  const tilt = particle.options.tilt,
    tiltAnimation = tilt.animation,
    speed = ((_particle$tilt$veloci = particle.tilt.velocity) !== null && _particle$tilt$veloci !== void 0 ? _particle$tilt$veloci : 0) * delta.factor,
    max = 2 * Math.PI,
    decay = (_particle$tilt$decay = particle.tilt.decay) !== null && _particle$tilt$decay !== void 0 ? _particle$tilt$decay : 1;
  if (!tiltAnimation.enable) {
    return;
  }
  switch (particle.tilt.status) {
    case "increasing":
      particle.tilt.value += speed;
      if (particle.tilt.value > max) {
        particle.tilt.value -= max;
      }
      break;
    case "decreasing":
    default:
      particle.tilt.value -= speed;
      if (particle.tilt.value < 0) {
        particle.tilt.value += max;
      }
      break;
  }
  if (particle.tilt.velocity && decay !== 1) {
    particle.tilt.velocity *= decay;
  }
}